<template>
  <div class="action-menu i-ml-6" data-testid="action-menu">
    <button
      class="d-flex justify-content-center align-items-center i-icon-button type-transparent md light action-menu__ellipsis-button"
      @click="toggleMenu($event)"
    >
      <i-icon
        symbol="medium-more-menu-vertical"
        class="menu-icon"
        :size="20"
      ></i-icon>
    </button>
    <div
      class="action-menu__popover d-flex flex-column"
      :class="{ 'bottom-row': bottomRow, open: showMenu }"
    >
      <div v-for="(action, index) in actions" :key="index">
        <button
          v-if="actionVisible(action)"
          :data-testid="'action-menu-button-' + index"
          :class="[
            action.destructive ? 'option_destructive' : 'option_default',
            'w-100 option d-flex align-items-center',
          ]"
          @click="onClick(action)"
        >
          <i-icon
            :symbol="action.icon"
            :size="16"
            class="menu-icon i-mr-6"
          ></i-icon>
          {{ action.text }}
        </button>
      </div>
    </div>
    <div v-if="showMenu" class="action-menu__overlay" @click="toggleMenu"></div>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: {
    'i-icon': iIcon,
  },
  props: {
    item: {
      default: undefined,
      type: Object,
    },
    actions: {
      default: undefined,
      type: Array,
    },
    bottomRow: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    onClick(action) {
      action.onClick(this.item);
      this.showMenu = false;
    },
    toggleMenu(event) {
      event.stopPropagation();
      this.showMenu = !this.showMenu;
    },
    actionVisible(action) {
      if (typeof action.isVisible === 'function') {
        return action.isVisible(this.item);
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-reset {
  background: transparent;
  border: 0;
}

.action-menu {
  position: relative;
  display: flex;
  justify-content: flex-end;

  &__ellipsis-button {
    ::v-deep .i-icon {
      stroke-width: 0 !important;
    }
  }
  &__popover {
    width: 180px;
    position: absolute;
    top: 46px;
    right: -4px;
    background-color: $light-neutral-default;
    z-index: 110;
    visibility: hidden;
    opacity: 0;
    transition: visibility, opacity 0.15s ease-in-out;

    &.open {
      visibility: visible;
      opacity: 1;
    }
    &.bottom-row {
      top: unset;
      bottom: 26px;
    }

    @include submenu-style;
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }

  .option {
    @extend .button-reset;
    padding: 9px 12px;
    border-radius: $base-unit;

    &_default {
      color: $light-neutral-120 !important;
      .menu-icon {
        color: $light-neutral-110 !important;
      }

      &:focus,
      &:hover,
      &:active {
        background-color: $light-neutral-30;
      }
    }

    &_destructive {
      color: $light-error-110 !important;
      .menu-icon {
        color: $light-error-110 !important;
      }

      &:focus,
      &:hover,
      &:active {
        background-color: $light-error-30;
      }
    }

    &:disabled {
      background: $light-neutral-default !important;
      color: $light-neutral-90 !important;
      .menu-icon {
        color: $light-neutral-90 !important;
      }
    }
  }
}
</style>
